const reactSelectOverWriteStyles = {
  control: provided => ({
    ...provided,
    borderRadius: "4px",
    height: "100%",
    cursor: "pointer",
    borderColor: undefined,
    borderStyle: undefined,
    borderWidth: undefined,
    minHeight: undefined,
    outline: undefined,
    boxShadow: undefined
  }),
  option: provided => ({
    ...provided,
    color: "black",
    minHeight: "28px",
    backgroundColor: "insert",
    "&:hover": {
      backgroundColor: "#f5f5f5"
    },
    "&:focus": {
      backgroundColor: "insert"
    }
  }),
  multiValueRemove: provided => ({
    ...provided,
    paddingLeft: undefined,
    paddingRight: undefined,
    marginRight: "2px",
    color: "red",
    "&:hover": {
      backgroundColor: "#E8ECF2",
      color: "red"
    }
  }),
  indicatorsContainer: provided => ({
    ...provided,
    height: "16px"
  }),
  menu: provided => ({ ...provided, left: 0, top: "30px" })
};

export default {
  ...reactSelectOverWriteStyles,
  container: provided => ({
    ...provided,
    height: "28px",
    border: "1px solid #E1E4EC",
    padding: "0 0 0 12px",
    color: "#4A4A4A"
  }),
  singleValue: provided => ({
    ...provided,
    transform: "translateY(-50%)"
  }),
  indicatorsContainer: provided => ({
    ...provided,
    height: "28px"
  }),
  valueContainer: provided => ({
    ...provided,
    padding: "0",
    width: "26px"
  }),
  indicatorSeparator: () => ({
    display: "none"
  }),
  menu: provided => ({ ...provided, left: 0, bottom: "30px", top: "unset" })
};
